import { apiFetch } from "../client"

interface DevSmsEntry {
  phoneNumber: string
  otp: string
  templateId: string
  sentAt: string
}

export async function listDevSms() {
  return apiFetch<{
    status: string
    data: { messages: DevSmsEntry[] }
    meta: { total: number }
  }>("/dev/sms")
}

export async function clearDevSms() {
  return apiFetch<{
    status: string
    data: { deleted: number }
  }>("/dev/sms", { method: "DELETE" })
}
